export const FeatureTypes = {
  CLOCK_HOURS: 'clock-hours',
  ABSENCES: 'absences',
  DOCUMENT_MANAGEMENT: 'document-management',
  INVOICES: 'invoices',
  BUDGETS: 'budgets',
  EXPENSES: 'expenses',
  WAYBILLS: 'waybills',
  PROFORMAS: 'proformas',
  SALES_TICKETS: 'sales-tickets',
  DEALS: 'deals',
  ONLINE_BOOKING: 'online-booking',
  PROJECTS: 'projects',
  INTERNAL_TASKS: 'internal-tasks',
  PAYMENTS: 'payments',
  CONTACTS: 'contacts',
  CATALOGUE: 'catalogue',
  REPORTS: 'reports',
  CALENDAR: 'calendar',
  LABOR_SERVICE: 'labor-service',
  ACCOUNTING_SERVICE: 'accounting-service',
  USERS: 'users',
  EQUIPMENT: 'equipment',
  STOPWATCH_WITH_PIN: 'stopwatch-with-pin',
} as const;
export type FeatureType = typeof FeatureTypes[keyof typeof FeatureTypes];
export const ModuleGroups = {
  PEOPLE: 'people',
  FINANCE: 'finance',
  CLIENTS: 'clients',
  OTHER: 'other',
  PROFESSIONAL_SERVICES: 'professional-services',
} as const;
export type ModuleGroup = typeof ModuleGroups[keyof typeof ModuleGroups];

export const PeopleZones = {
  OWN: 'own',
  TEAM: 'team',
} as const;
export type PeopleZone = typeof PeopleZones[keyof typeof PeopleZones];

export const SidebarActionTypes = {
  MODULE_MANAGEMENT: 'module-management',
  SETTINGS: 'settings',
} as const;
export type SidebarActionType = typeof SidebarActionTypes[keyof typeof SidebarActionTypes];
